import links from "@/links/links";

export default {
  actions: {
    FETCH(agencyId) {
      return this.get(links.RECIPIENT_GET_BY_AGENCY(agencyId), {
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.RECIPIENT_GET(id));
    },
    GET_BY_BUILDING_ID(buildingId) {
      return this.get(links.RECIPIENTS_GET_BY_BUILDING_ID(buildingId), {
        dataKey: "hydra:member",
      });
    },
    POST(item) {
      return this.post(links.RECIPIENT_POST(), item);
    },
    PUT(item) {
      return this.put(links.RECIPIENT_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.RECIPIENT_DELETE(item.id), {
        delete: item.id,
      });
    },
    GET_BY_MEETING(meetingId) {
      return this.get(links.RECIPIENTS_GET_BY_MEETING(meetingId), {
        dataKey: "hydra:member",
      });
    },
  },
};
